import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { ADTSettings  } from 'angular-datatables/src/models/settings';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { BasicActionsEventType } from '../DatatableEvents/basic-actions-event-type';
import { BasicActionsComponent } from '../DatatableEvents/basic-actions.component';
class DataTablesResponse {
  data: any[];
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-admin-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss']
})
export class VideosComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  @ViewChild('basicActions') basicActions: TemplateRef<BasicActionsComponent>;
  message = '';
  editVideo=null;
  modalid="newvideo"
  modalid1="deletecommon"
  deleteid=""
  attributeList: any;
  rulesList: any = []
  rules: any = ""
  levelsList: any = []
  levels: any = ""
  categoryList: any = []
  category: any = ""
  skillsList: any = []
  skill: any = ""
  disableLevel: boolean = true
  disableCategory: boolean = true
  disableSkills: boolean = true
  filterableAttribtute:any={};
  attri : any = []
  
  dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  //dtOptions: DataTables.Settings = {};
  dtOptions: ADTSettings = {};
  
  constructor(public adminApi: AdminapiService,public webApi: WebapiService){

  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      
      $('table.dataTable').DataTable().clearPipeline().draw();
      //dtInstance.clearPipeline().draw()
      //dtInstance.clear().draw();
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(this.dtOptions);
    });
  }

  changeData(event){
    this.rerender()
  }

  ngOnInit(): void {
    this.allRules()
    setTimeout(() => {
      const self = this;
      this.dtOptions = {
        serverSide: true,  
        ordering:false,
        searching:false,
        processing: true,
        lengthMenu:['10','20','30','40','50'],
        //order: [[0, 'desc']],
        //columnDefs: [{ targets: 3, orderable: false }],
        pageLength: 50,   // Set the flag 
        ajax: this.getVideos(),
        columns: [{
          title: 'ID',
          data: 'id'
        }, {
          title: 'Name',
          data: 'name'
        }, {
          title: 'Category',
          data: 'category'
        }, {
          title: 'Skills',
          data: 'skills'
        }
        ,
        {
          title: 'Actions',
          data: null,
          ngTemplateRef: {
            ref: this.basicActions,
            context: {
              // needed for capturing events inside <ng-template>
              captureEvents: self.onCaptureEvent.bind(self),
            }
          }
        
        }
      ]
      };
      
    });
  }

  getVideos(){
    let params= {
      "rules":this.rules,
      "levels":this.levels,
      "skill":this.skill,
      "category":this.category,
      "attr":JSON.stringify(this.filterableAttribtute)
    }
    return this.adminApi.getVideos(params)
  }
  
  ngAfterViewInit() {
    setTimeout(() => {
      // race condition fails unit tests if dtOptions isn't sent with dtTrigger
      this.dtTrigger.next(this.dtOptions);
    }, 200);
  }

  onCaptureEvent(event: BasicActionsEventType) {
    //this.message = `Event '${event.cmd}' with data '${JSON.stringify(event.data)}`;
    if(event.cmd=='edit'){
      this.editVideo = event.data;
      this.openModal()
    }
    if(event.cmd=='delete'){
      this.deleteid = event.data.id;
      this.openConfirmModal()
    }
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  addNewModal() {
    this.editVideo = null;

    this.openModal()
  }

  openModal(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }

  openConfirmModal(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid1)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid1), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }

  toLower(title){
    return title.toLowerCase().charAt(0).toUpperCase() + title.toLowerCase().slice(1);;
  }

  allRules() { 
    this.attributeList=[]
    this.webApi.allConditions().subscribe((data: []) => {
      this.rulesList = data;
      if ($(".selectpicker.rules").length != 0 && this.rulesList) {
        setTimeout( ()=> { 
           $('.selectpicker.rules').selectpicker('refresh');  
        }, 500);  
      } 
    });
  }

  allLevelsOfRule() {
    this.attributeList=[]
    if(this.rules) {
      let selectedrule = this.rulesList.find((rule:any) => rule.id == this.rules)
      if(selectedrule){
        this.levelsList = selectedrule['levels'];
        this.disableLevel = false;
        if ($(".selectpicker.level").length != 0 && this.rules) {
          setTimeout( ()=> { 
              $('.selectpicker.level').selectpicker('refresh');  
          }, 500);  
        } 
      }
 
    } 
    else {
      this.levelsList = []
      this.levels = ""
      this.disableLevel = true;
      setTimeout( ()=> {
        $('.selectpicker.level').selectpicker('refresh');  
       }, 0);  
    }  
  }

  allCategories() {
    this.attributeList=[]
    if(!this.categoryList.length && this.rules) {
      
      let selectedrule = this.rulesList.find((rule:any) => rule.id == this.rules)
      if(selectedrule)
        this.categoryList = selectedrule['categories']
        this.disableCategory = false;
        if ($(".selectpicker.category").length != 0 && this.rules) {
          setTimeout( ()=> {
              $('.selectpicker.category').selectpicker('refresh');
          }, 550); 
        }
    } 
    else   {  // Don't make Api call once we have categories
        this.category = "";
        this.disableSkills = true;
        this.skill = "";
        if(!this.levels) 
          this.disableCategory = true; 
        else 
          this.disableCategory = false;
          setTimeout( ()=> {
             $('.selectpicker.category, .selectpicker.skill').selectpicker('refresh');
          }, 0);  
    }
  }

  allSkills() {
    
    //if(!this.skillsList.length) {
      if(this.category){
        let selectedcat = this.categoryList.find((category:any) => category.id == this.category)
        if(selectedcat)
          this.skillsList = selectedcat['skills'];
          this.disableSkills = false; 
          this.showAttributes();
          if ($(".selectpicker.skill").length != 0 && this.rules) {
            setTimeout( ()=> {
              $('.selectpicker.skill').selectpicker('refresh');
            }, 550); 
          }
      }
      
    //} 
    //else {  // Don't make Api call once we have skills
      this.showAttributes();
      this.skill = "";
      if(!this.category)
        this.disableSkills = true;
      else 
        this.disableSkills = false;  
          setTimeout( ()=> {
             $('.selectpicker.skill').selectpicker('refresh');
          }, 0);  
    //}
   
  }
   
  showAttributes() {  
    this.filterableAttribtute={};
    $('.selectpicker.attributes').val('').trigger('change');
    let selectedcat = this.categoryList.find((category:any) => category.id == this.category)
    if(selectedcat)
      this.attributeList = selectedcat['attributes'];
      setTimeout( ()=> {
          $('.selectpicker.attributes').selectpicker('refresh');
      }, 550); 
       
  }

  getAttributesVal(e:any,option:any) {
    //console.log(this.attri);
    //console.log("options_value"+option+'_'+e?.target?.value);
    let found = Object.keys(this.filterableAttribtute).map((index:any,item:any)=> { return index == option})
    if(found.length){
      delete this.filterableAttribtute[option];
    }
    // else{
    //   this.filterableAttribtute[option]=option+'_'+e?.target?.value;
    // }
    this.filterableAttribtute[option]=option+'_'+e?.target?.value;

    //console.log(this.filterableAttribtute)
  }

  search(){
    const self = this;
    
    this.dtOptions.ajax = this.getVideos()
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      $('table.dataTable').DataTable().clearPipeline();
      dtInstance.destroy(false);
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(this.dtOptions);
    });
  }

  resetSearch(){
    this.category = "";
    this.levels = "";
    this.rules = "";
    this.skill = "";
    this.filterableAttribtute={};
    this.attributeList = [];
    this.disableCategory = true;
    this.disableSkills = true;
    this.disableLevel = true;
    this.disableSkills = true;
    setTimeout( ()=> {
      $('.selectpicker.rules,.selectpicker.level, .selectpicker.category, .selectpicker.skill, .selectpicker.attributes').selectpicker('refresh');
      this.dtOptions.ajax = this.getVideos()
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        // Destroy the table first
        $('table.dataTable').DataTable().clearPipeline();
        dtInstance.destroy(false);
        // Call the dtTrigger to rerender again
        this.dtTrigger.next(this.dtOptions);
      });
    }, 0);
  }

}
